import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import AddCardTile from './components/AddCardTile';
import LinkOffersTile from './components/LinkOffersTile';

import './InstoreEducationalTile.scss';

function InstoreEducationalTile({ offers, shouldShowTile, shouldUseDesktopTileOnMobile }) {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const hasCards = !isEmpty(offers[0].cards);

  const tileViewClassName = (isMobileMQ && !shouldUseDesktopTileOnMobile) ? 'mn_mobile' : 'mn_desktop';

  if (!shouldShowTile) {
    return null;
  }

  return (
    hasCards
      ? <LinkOffersTile tileViewClassName={tileViewClassName} />
      : <AddCardTile tileViewClassName={tileViewClassName} />
  );
}

export default (props) => <ComponentErrorBoundary><InstoreEducationalTile {...props} /></ComponentErrorBoundary>;
